import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  textarea: {
    maxHeight: 66,
    height: '66px !important'
  },
  cardWrapper: {
    textAlign: 'left',
    '.ant-card-body': {
      borderRadius: 6,
      backgroundColor: token.lightGrey.lightGrey3
    }
  },
  card: {
    '.ant-card-body': {
      backgroundColor: `${token.colorWhite} !important`,
      borderRadius: 6
    }
  },
  collapseItem: {
    marginBottom: 8,
    '.ant-collapse-header': {
      borderRadius: '6px !important'
    }
  }
}))
